export enum FilterFieldsKeys {
  ChainName = "chain_name",
  Currency = "currency",
  ClientId = "client_id",
}

export type FilterFields = {
  [FilterFieldsKeys.ChainName]: string;
  [FilterFieldsKeys.Currency]: string;
  [FilterFieldsKeys.ClientId]: string;
};
